import { Y42FeatureType } from '@y42/json-schema';
import { AbstractFeatureChildUIModel, AbstractFeatureUIModel } from './abstract-feature.model';

const Y42FeatureHierarchy = {
  [Y42FeatureType.Catalog]: null,
  [Y42FeatureType.Export]: {
    Trigger: { ExportTriggerJob: true },
  },
  [Y42FeatureType.Integration]: {
    DatasourceTable: { DatasourceTableJob: true },
  },
  [Y42FeatureType.Lineage]: null,
  [Y42FeatureType.Orchestration]: {
    OrchestrationRun: true,
  },
  [Y42FeatureType.SqlModel]: {
    DatasourceTable: { DatasourceTableJob: true },
  },
  [Y42FeatureType.StatusAlert]: null,
  [Y42FeatureType.UiModel]: {
    DatasourceTable: { DatasourceTableJob: true },
  },
  [Y42FeatureType.VisualizationDashboard]: {
    VisualizationTab: { Widget: true },
  },
  [Y42FeatureType.VisualizationFilter]: null,
  [Y42FeatureType.VisualizationTheme]: null,
  [Y42FeatureType.VisualizationWidget]: null,
} as const;

const __TYPE_CHECK__Y42FeatureHierarchy: Record<Y42FeatureType, unknown> = Y42FeatureHierarchy;
type Y42FeatureHierarchyType = typeof Y42FeatureHierarchy;

export type Y42FeatureChildOf<T extends Y42FeatureType> = keyof Y42FeatureHierarchyType[T];
export type Y42FeatureGrandChildOf<T extends Y42FeatureType> =
  keyof Y42FeatureHierarchyType[T][keyof Y42FeatureHierarchyType[T]];

type NestedKeyOf<ObjectType extends object | null> = {
  [Key in keyof ObjectType]: ObjectType[Key] extends object ? keyof ObjectType[Key] : null;
}[keyof ObjectType];

export type Y42FeatureChildren = NestedKeyOf<Y42FeatureHierarchyType>;

type Y42FeatureChildEnum = {
  [K in NonNullable<Y42FeatureChildren>]: K;
};

export const Y42FeatureChildType: Y42FeatureChildEnum = {
  DatasourceTable: 'DatasourceTable',
  OrchestrationRun: 'OrchestrationRun',
  Trigger: 'Trigger',
  VisualizationTab: 'VisualizationTab',
};

export function isFeatureUIModel(
  model: AbstractFeatureUIModel | AbstractFeatureChildUIModel,
): model is AbstractFeatureUIModel {
  return model.$level === 0;
}

export function isFeatureChildUIModel(
  model: AbstractFeatureUIModel | AbstractFeatureChildUIModel,
): model is AbstractFeatureChildUIModel {
  return model.$level === 1;
}
